/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** CreateAuthRequest — dark-roast DTO: AuthPostDTO */
export const createAuthRequestSchema = z.object({ "email": z.string().min(1), "mfaCode": z.string().nullish(), "password": z.string().min(1) });
export type CreateAuthRequest = z.infer<typeof createAuthRequestSchema>;
